'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('@esnpm/translate');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Select = require('./Select');

var _redux = require('redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonGroup = (_temp = _class = function (_BaseSelect) {
	_inherits(ButtonGroup, _BaseSelect);

	function ButtonGroup(props) {
		_classCallCheck(this, ButtonGroup);

		return _possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).call(this, props));
	}

	_createClass(ButtonGroup, [{
		key: 'render',
		value: function render() {
			if (!this.props.componentOptions) {
				return _react2.default.createElement(
					_reactBootstrap.ButtonGroup,
					null,
					this.renderOptions()
				);
			} else {
				return _react2.default.createElement(
					_react.Fragment,
					null,
					this.renderComponentOptions(this.props.options)
				);
			}
		}
	}, {
		key: 'handleOnClick',
		value: function handleOnClick(e) {
			this.handleOnChange(e);
			this.props.onFocus();
		}
	}, {
		key: 'realRenderOptions',
		value: function realRenderOptions(intermediateOptions) {
			var _this2 = this;

			return intermediateOptions.map(function (entry) {
				var b = _this2.state.val == entry.value;
				var cn = (0, _classnames2.default)({ active: b, "btn-primary": b }, { disabled: _this2.props.disabled });
				return _react2.default.createElement(
					_reactBootstrap.Button,
					{
						key: entry.value,
						value: entry.value,
						className: cn,
						onClick: _this2.handleOnClick.bind(_this2),
						bsSize: _this2.props.bsSize
					},
					entry.text
				);
			});
		}
	}, {
		key: 'renderComponentOptions',
		value: function renderComponentOptions(childs) {
			var _this3 = this;

			return childs.map(function (element) {
				return _react2.default.cloneElement(element, Object.assign({}, element.props, {
					onClick: _this3.handleChildOnClick.bind(_this3),
					ButtonGroupValue: element.key,
					active: _this3.state.val == element.key
				}));
			});
		}
	}, {
		key: 'handleChildOnClick',
		value: function handleChildOnClick(component) {
			this.setVal(component.props.ButtonGroupValue);
		}
	}]);

	return ButtonGroup;
}(_Select.BaseSelect), _class.defaultProps = Object.assign({}, _Select.BaseSelect.defaultProps, {
	componentOptions: false
}), _class.propTypes = Object.assign({}, _Select.BaseSelect.propTypes, {
	componentOptions: _propTypes2.default.bool
}), _temp);
exports.default = (0, _redux.compose)(_translate.withTrContext)(ButtonGroup);